import React, { useRef, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import HelpCenterAccordionComponent from "./HelpCenterAccordionComponent";
import { usingCoinsData } from "../../Api/help-center-json-data/using-tokens-belts-coins";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";

const HelpCenterPopupComponent = ({ steps, topData, bottomData, tab = "" }) => {
  const [expandedStep, setExpandedStep] = useState(null);
  const [expandedCoinsStep, setExpandedCoinsStep] = useState(null);
  const isStepDescriptionEmpty = (step) => {
    return step && step.Description && step.Description.length === 0;
  };
  const navigation = useNavigation();

  return (
    <View>
      {topData && topData.length > 0 && (
        <View>
          {topData?.map((text, index) => (
            <Text
              key={`top-${index}`}
              style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}
            >
              {text}
            </Text>
          ))}
        </View>
      )}

      <View
        style={{
          marginTop: topData && topData.length > 0 ? 20 : 0,
          marginBottom: bottomData && bottomData.length > 0 ? 25 : 0,
          borderWidth: 1,
          borderColor: AppColors.white,
        }}
      >
        <HelpCenterAccordionComponent
          steps={steps}
          expandedStep={expandedStep}
          setExpandedStep={setExpandedStep}
          isDescriptionEmpty={
            expandedStep !== null && isStepDescriptionEmpty(steps[expandedStep])
          }
        />
        {expandedStep !== null &&
          isStepDescriptionEmpty(steps[expandedStep]) && (
            <View
              style={{
                marginHorizontal: 20,
                marginBottom: 20,
                borderWidth: 1,
                borderColor: AppColors.white,
              }}
            >
              <HelpCenterAccordionComponent
                steps={usingCoinsData.Coins.Steps}
                expandedStep={expandedCoinsStep}
                setExpandedStep={setExpandedCoinsStep}
              />
            </View>
          )}
      </View>

      {bottomData && bottomData.length > 0 && (
        <View>
          {bottomData?.map((text, index) => (
            <Text
              key={`bottom-${index}`}
              style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}
            >
              {text}
            </Text>
          ))}
        </View>
      )}

      {tab === "DisputeCenter" && (
        <TouchableOpacity
          onPress={() => {
            navigateToScreen(navigation, AppScreens.DisputeCenter);
          }}
        >
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}>
            Go To Dispute Centre
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default HelpCenterPopupComponent;
